var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter } from '@angular/core';
import { PageNames } from '../../shared/page-names.enum';
import { TvShopEntertainmentPack } from '../../model/tv-shop-entertainment-pack';
import { NavigationService } from '../../services/navigation/navigation.service';
import { BaseActions } from '../../shared/base-actions';
import { ImageUtils } from '../../shared/utils/image/image-utils';
import { OmapiIdConstants } from '../../shared/omapi-id-constants';
var ProductDetailEntertainmentComponent = /** @class */ (function (_super) {
    __extends(ProductDetailEntertainmentComponent, _super);
    function ProductDetailEntertainmentComponent(navigationService) {
        var _this = _super.call(this) || this;
        _this.navigationService = navigationService;
        _this.showBannerImage = true;
        _this.emitOrderProduct = new EventEmitter();
        _this.componentName = PageNames.DETAIL_PAGE_ENTERTAINMENT;
        return _this;
    }
    Object.defineProperty(ProductDetailEntertainmentComponent.prototype, "backgroundImageUrl", {
        get: function () {
            return ImageUtils.getBackgroundImageUrl(this.pack.omapiId, this.componentName);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductDetailEntertainmentComponent.prototype, "bannerImageUrl", {
        get: function () {
            return ImageUtils.getBannerImageUrl(this.pack.omapiId, this.componentName);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductDetailEntertainmentComponent.prototype, "logoUrl", {
        get: function () {
            return ImageUtils.getLogoUrlForOmapiId(this.pack.omapiId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductDetailEntertainmentComponent.prototype, "isOmapiBETVSport", {
        get: function () {
            return this.pack && this.pack.omapiId !== OmapiIdConstants.BE_TV_SPORT_VLA;
        },
        enumerable: true,
        configurable: true
    });
    ProductDetailEntertainmentComponent.prototype.onEmitOrderProduct = function (event) {
        if (!this.pack.isOrderable() && this.subPack && this.subPack.isOrderable()) {
            this.transformSubpackToPack(event);
        }
        this.emitOrderProduct.emit(event);
    };
    ProductDetailEntertainmentComponent.prototype.transformSubpackToPack = function (event) {
        event.packOmapiId = event.subPackOmapiId;
        event.packPrice = event.subPackPrice;
        event.subPackOmapiId = undefined;
        event.subPackPrice = undefined;
    };
    ProductDetailEntertainmentComponent.prototype.onBack = function () {
        this.navigationService.resetPage();
    };
    return ProductDetailEntertainmentComponent;
}(BaseActions));
export { ProductDetailEntertainmentComponent };
